import { Component } from '@angular/core';

@Component({
  selector: 'app-nointernet',
  templateUrl: './nointernet.component.html',
  styleUrl: './nointernet.component.scss'
})
export class NointernetComponent {

}
